var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.regions && _vm.regions[0] && _vm.regions[0].code)?_c('div',{staticClass:"region-list"},[_vm._t("default",null,{"regions":_vm.regions,"regionsByLetter":_vm.regionsByLetter})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }